import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function collapseGroup({ component, key } = {}) {
  let data = component.props.pageComponent.state.jobAssessmentChecklistGroupList.map((group, i) => {
    if (group.key === key) {
      if (group.Collapsed !== true) {
        group.Collapsed = true;
      } else {
        group.Collapsed = false;
      }
    }
    return group;
  });
  component.setState({ jobAssessmentChecklistGroupList: data });
}

export function addJobAssessmentChecklist({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    // sectionComponent.customForm.current?.getComponentDataSource();

    //设置默认选择的Folder和Group
    let formData = parameter;
    //设置富文本的控件为空字符串，否则会崩
    formData['Comments'] = '';
    formData['Note'] = '';
    formData['Guideline'] = '';
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });

    setTimeout(() => {
      if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'] !== undefined) {
        if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'].filter(c => c.Key == 'Compliance Assessment').length > 0) {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'].filter(c => c.Key == 'Compliance Assessment')[0].Value);
        } else {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'][0].Value);
        }
      }
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function refreshData({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getJobAssessmentChecklistFolderData(pageComponent.state.jobAssessmentChecklistFolderData.JobAssessmentChecklistFolderId);
}

export function deleteJobAssessmentChecklistRun({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getJobAssessmentChecklistFolderData(pageComponent.state.jobAssessmentChecklistFolderData.JobAssessmentChecklistFolderId);
}

export function getChecklistStatusSetIdDataSourceRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'] !== undefined) {
      if (sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'].filter(c => c.Key == 'Compliance Assessment').length > 0) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'].filter(c => c.Key == 'Compliance Assessment')[0].Value);
      } else {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', sectionComponent.customForm.current?.state.componentDataSource['ChecklistStatusSetId'][0].Value);
      }
    }
  }, config.setTimeoutMilliSecond);
}

export function editJobAssessmentChecklistPopUpRun({ parameter, sectionComponent, formComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ jobAssessmentChecklistId: parameter.key });

  setTimeout(() => {
    //设置联动的Select
    getChecklistStatusSelectOptionList({ sectionName: sectionName, parameter: parameter.ChecklistStatus.ChecklistStatusSetId, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
  }, config.setTimeoutMilliSecond);
}


export function getChecklistStatusSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusSetId', parameter);
  httpClient
    .get('Admin/ChecklistStatus/GetSelectOptionList?parameterId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        dataSource = dataSource.filter(item => item.Value !== 0);
        componentDataSource['ChecklistStatusId'] = dataSource;
        formComponent.setState({ componentDataSource });
        if (dataSource.length > 0) {
          if (dataSource.filter(item => item.Value === sectionComponent.customForm.current?.formRef.current?.getFieldValue('ChecklistStatusId')).length === 0) {
            //搜到的数据源不包括当前值, 说明更换了StatusSet, Status选择新StatusSet里第一个值
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusId', dataSource[0].Value);
          }
        } else {
          //搜不到数据源, 移除Status
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ChecklistStatusId', null);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function quickChangeStatus({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  console.log(parameter.key, 'quickChangeStatus')
  console.log(pageComponent.state.checklistStatusId, 'quickChangeStatus')
  let jobAssessmentChecklistGroupList = pageComponent.state.jobAssessmentChecklistGroupList.map((group, i) => {
    group.JobAssessmentChecklistList.map((jobAssessmentChecklist, k) => {
      if (jobAssessmentChecklist.key === parameter.key) {
        jobAssessmentChecklist.Loading = true;
      }
      return jobAssessmentChecklist;
    });
    return group;
  })

  setTimeout(() => {
    //写后台
    httpClient
      .put('Business/JobAssessmentChecklist/QuickChangeStatus', { key: parameter.key })
      .then(({ data }) => {
        if (data.result) {
          pageComponent.getJobAssessmentChecklistFolderData(pageComponent.state.jobAssessmentChecklistFolderData.JobAssessmentChecklistFolderId);
          pageComponent.getAllJobAssessmentChecklistStatusCounts();
          if (pageComponent.state.checklistStatusId !== 0 && pageComponent.state.checklistStatusId !== parameter.key) {
            pageComponent.GetByStatusJobAssessmentChecklistSectionTreeModel(pageComponent.state.checklistStatusId)
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
  e.stopPropagation();
  return false;
}

export function showStatusMenu({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ event: e, statusMenuShow: true, checklistStatusSetId: parameter.ChecklistStatusSetId, jobAssessmentChecklistId: parameter.JobAssessmentChecklistId });
  e.preventDefault();
  return false;
}
export function showGroupStatusMenu({ e, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ event: e, groupStatusMenuShow: true, checklistStatusSetId: parameter.ChecklistStatusSetId, jobAssessmentChecklistId: parameter, jobAssessmentChecklistGroupId: parameter.JobAssessmentChecklistGroupId });
  return false;
}

export function changeStatus({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  //写后台
  httpClient
    .put('Business/JobAssessmentChecklist/ChangeStatus', { key: parameter.key, ChecklistStatusId: parameter.checklistStatusId })
    .then(({ data }) => {
      if (data.result) {
        pageComponent.getJobAssessmentChecklistFolderData(pageComponent.state.jobAssessmentChecklistFolderData.JobAssessmentChecklistFolderId);
        pageComponent.getAllJobAssessmentChecklistStatusCounts();
        if (pageComponent.state.checklistStatusId !== 0 && pageComponent.state.checklistStatusId !== parameter.checklistStatusId) {
          pageComponent.GetByStatusJobAssessmentChecklistSectionTreeModel(pageComponent.state.checklistStatusId)
        }
        pageComponent.setState({ statusMenuShow: false });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function changeGroupStatus({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let Key = []
  let jobAssessmentChecklistGroupList = parameter.key.map((group, i) => {
    if (group.key === pageComponent.state.jobAssessmentChecklistGroupId) {
      group.JobAssessmentChecklistList.map((jobAssessmentChecklist, k) => {
        Key.push(jobAssessmentChecklist.key)
      })
    }
  })
  // //写后台
  httpClient
    .put('Business/JobAssessmentChecklist/ChangeStatusGroup', { AssessmentChecklistIds: Key, ChecklistStatusId: parameter.checklistStatusId })
    .then(({ data }) => {
      if (data.result) {
        pageComponent.getJobAssessmentChecklistFolderData(pageComponent.state.jobAssessmentChecklistFolderData.JobAssessmentChecklistFolderId);
        pageComponent.getAllJobAssessmentChecklistStatusCounts();
        if (pageComponent.state.checklistStatusId !== 0 && pageComponent.state.checklistStatusId !== parameter.checklistStatusId) {
          pageComponent.GetByStatusJobAssessmentChecklistSectionTreeModel(pageComponent.state.checklistStatusId)
        }
        pageComponent.setState({ groupStatusMenuShow: false });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}


export function editBySection({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.setState({ componentDataSource: [] });
  pageComponent.setState({ jobAssessmentChecklist: parameter });
  setTimeout(() => {
    sectionComponent.setState({ showModal: true, componentType: 'Edit' });
    setTimeout(() => {
      sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
      sectionComponent.customForm.current?.getComponentDataSource();
      httpClient
        .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
        .then(({ data }) => {
          if (data.result) {
            if (data.data['Requirement'] === null) {
              data.data['Requirement'] = '';
            }
            if (data.data['Comments'] === null) {
              data.data['Comments'] = '';
            }
            if (data.data['Note'] === null) {
              data.data['Note'] = '';
            }
            sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });

            //把处理后的数据赋值给表单
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
            sectionComponent.customForm.current?.setState({ formData: data.data });

          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function assessmentChecklistTemplateCommentOptionChange({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (parameter != 0) {
    httpClient
      .get('Admin/AssessmentChecklistTemplateCommentOption/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          let comments = formComponent.formRef.current?.getFieldValue('Comments');
          let newComments = comments + data.data.Content;
          formComponent.formRef.current?.setFieldValue('Comments', newComments);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function assessmentChecklistTemplateNoteOptionChange({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (parameter != 0) {
    httpClient
      .get('Admin/AssessmentChecklistTemplateNoteOption/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          let note = formComponent.formRef.current?.getFieldValue('Note');
          let newNote = note + data.data.Content;
          formComponent.formRef.current?.setFieldValue('Note', newNote);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function showCommentsTemplateOptionsDiv({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let assessmentChecklistTemplateId = pageComponent.state.jobAssessmentChecklist.AssessmentChecklistTemplateId;
  console.log(assessmentChecklistTemplateId);
  if (assessmentChecklistTemplateId == null) {
    pageComponent.setState({ commentsTemplateOptionsShow: true });
  } else {
    pageComponent.setState({ commentsTemplateOptionsShow: true, assessmentChecklistTemplateId });
    pageComponent.commentsTemplateOptions.current?.getCommentsTemplateOptions(assessmentChecklistTemplateId);
  }

}

export function showRequirementTemplateOptionsDiv({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let assessmentChecklistTemplateId = pageComponent.state.jobAssessmentChecklist.AssessmentChecklistTemplateId;
  console.log(assessmentChecklistTemplateId);
  if (assessmentChecklistTemplateId == null) {
    pageComponent.setState({ requirementTemplateOptionsShow: true });
  } else {
    pageComponent.setState({ requirementTemplateOptionsShow: true, assessmentChecklistTemplateId });
    pageComponent.requirementTemplateOptions.current?.getRequirementTemplateOptions(assessmentChecklistTemplateId);
  }
}

//Copy
export function copyJobAssessmentChecklist({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  uie.icon = 'loading.svg'
  httpClient
    .post(pageComponent.props.areaName + '/' + sectionName + '/Copy', parameter)
    .then(({ data }) => {
      if (data.result) {
        uie.icon = 'copy.svg'
        pageComponent.getJobAssessmentChecklistFolderData(pageComponent.state.jobAssessmentChecklistFolderData.JobAssessmentChecklistFolderId);
      } else {
        uie.icon = 'copy.svg'
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      uie.icon = 'copy.svg'
      globalFunction.handleError(error, pageComponent);
    });
}